import { render, staticRenderFns } from "./Buildings.vue?vue&type=template&id=04bc1014&scoped=true&"
import script from "./Buildings.vue?vue&type=script&lang=ts&"
export * from "./Buildings.vue?vue&type=script&lang=ts&"
import style0 from "./Buildings.vue?vue&type=style&index=0&id=04bc1014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc1014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VIcon,VMenu,VTooltip})
